import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";

export class GetMFAStatusResData extends ApiGenericResponse {
    isEnabled: boolean = false;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.isEnabled = response.data.Payload.IsEnabled;
        }
    }
}
